import React from 'react';
import './BotonDeslizador.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'

const IZQUIERDA=1;
const DERECHA=2;

const BotonDeslizador = (props) => {

    return (
        <div onClick={()=>{props.deslizar(props.direccion)}} className={props.direccion==IZQUIERDA
        ?"btn-deslizador btn-deslizador-izquierdo":"btn-deslizador btn-deslizador-derecho"}>
            <FontAwesomeIcon icon={props.direccion==IZQUIERDA
                ?faChevronLeft:faChevronRight} size="lg" color="#7a7a7a" />
        </div>)

}

export default BotonDeslizador;

